
import React from 'react';
import { FlowRender } from "../flow-render";
import {TextLoading} from "../../client/funcs/utils";
import {Action} from "../../client/funcs/utils";
import {GoLiveController} from "../onboarding-shared/go-live-controller";

class SigningDone extends FlowRender {

  onMount(component) {
    const ctrl = new GoLiveController(component);
    ctrl.goLive();
  }

  onClick = component => () => {
    component.props.navigatePath("/user", {
      acct_index: component.getOnboardingIndex(),
    })
  }

  renderNavButton = component => {
    return (
      <div>
        <div style={{height: "2rem"}}/>
        <Action onClick={this.onClick(component)}>
          <TextLoading
            label={"Go to Dashboard"}/>
        </Action>
      </div>
    )
  }

  renderBody = component => {
    const done_title = "Congratulations";
    const text_0 = "Your account is being reviewed and will be opened shortly.";
    const text_1 = "We'll send a notification as soon as its ready.";
    const larger = {
      fontSize: "1.5rem",
    }
    return (
      <div>
        <div align={"center"}>
          <div style={{fontSize: "2.5rem"}}>{done_title}</div>
          <div style={{height: "2rem"}}/>
          <div style={larger}>
            <div>{text_0}</div>
            <div>{text_1}</div>
          </div>
          { this.renderNavButton(component) }
        </div>
      </div>
    )
  }

  render = component => {
    return this.renderSingleColumn(this.renderBody(component));
  }
}

export { SigningDone };
